import FirebaseContext, { withFirebase, useFirebase } from "./context";
import Firebase from "./firebase";

export default Firebase;

export { FirebaseContext, withFirebase, useFirebase };
